import { useQuery, gql, useLazyQuery } from '@apollo/client';
import {
  ProjetoOfertasQuery,
  ProjetoOfertasQueryVariables,
} from './__generated__/ProjetoOfertasQuery';

const OFERTAS_QUERY = gql`
  query ProjetoOfertasQuery($descricao: String, $pagina: Int, $itens_por_pagina: Int) {
    ofertas(
      filter: { descricao: $descricao, pagina: $pagina, itens_por_pagina: $itens_por_pagina }
    ) {
      id_oferta
      num_oferta
      num_ano
      num_semestre
      curso {
        id_curso
        dsc_nome_curso
        dsc_sigla_curso
      }
    }
  }
`;

const useOfertasQuery = (variables: ProjetoOfertasQueryVariables) => {
  return useQuery<ProjetoOfertasQuery, ProjetoOfertasQueryVariables>(OFERTAS_QUERY, {
    variables,
  });
};

const useOfertasLazyQuery = () => {
  return useLazyQuery<ProjetoOfertasQuery, ProjetoOfertasQueryVariables>(OFERTAS_QUERY);
};

export { useOfertasQuery, useOfertasLazyQuery };
